<template>
    <div class="card" @mouseover="hover = true" @mouseleave="hover = false">
        <div class="images">
            <div class="image" id="image3" :style="{'background-image': 'url(' + require('@/assets/asics.jpg') + ')'}"></div>
            <div class="image" id="image2" :style="{'background-image': 'url(' + require('@/assets/asics.jpg') + ')'}"></div>
            <div class="image" id="image1" :style="{'background-image': 'url(' + require('@/assets/asics.jpg') + ')'}"></div>
        </div>
        
        <div class="bottom">
            <transition name="card-fade">
                <div class="menu" v-if="hover">
                    <div class="buttons">
                        <div class="analyze" @click="sendBack">View</div>
                        <div class="actions">
                            <div class="edit">
                                <bg-icon name="fedit"></bg-icon>
                            </div>
                            <div class="delete">
                                <bg-icon name="fdelete"></bg-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <div class="details">
                <div class="title">
                    <span>{{ project.title }}</span>
                </div>
                <div class="right-details">
                    <p>Heatmaps: <b>12</b></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BgIcon from '@/components/bg-icon'
export default {
    props: [ 'project'],
    components: {
        BgIcon
    },
    data() {
        return {
            hover: false,
        }
    },
    methods: {
        sendBack() {
            this.$emit("analyze", this.id );
        }
    }
}
</script>

<style lang="scss" scoped>
@import './styles.scss'
</style>